// src/utils/listingLeadStages.js
// Pure, Firebase-free helpers for the Listing (seller) pipeline — mirrors
// buyerLeadStages.js. The pipeline holds the whole listing chase; a lead
// graduates onto the Deals Board (at Pre-Market) once the listing is signed —
// from Listing Appointment OR from the parked stages (Deferred / Next Year),
// per the drawer's graduate button. (2026-07-15: the "Appt Held" and "CMA"
// stages were removed; existing leads there were migrated to Listing Appointment
// and Appt Set respectively.)

// The auto-intake column for open-house sign-ins whose guest is selling.
// Mirrors OPEN_HOUSE_LEADS_STAGE in buyerLeadStages.js and the server trigger
// (functions-drive/openHouseMapping.js). A starting column, not a parked one,
// so nextStage() from here advances to New Lead.
export const OPEN_HOUSE_LEADS_STAGE = "Open House Leads";

export const LISTING_STAGES = [
  OPEN_HOUSE_LEADS_STAGE,
  "New Lead",
  "Contacted",
  "Appt Set",
  "Listing Appointment",
  "Deferred",
  "Next Year",
];

// The last active step before signing. isGraduationStage marks this stage, but
// it is NOT the gate for which stages may graduate — the drawer's button also
// offers it from the parked stages (see PARKING_STAGES).
export const GRADUATION_STAGE = "Listing Appointment";

export const STAGE_COLORS = {
  "Open House Leads": "#0284c7",
  "New Lead": "#94a3b8",
  Contacted: "#3b82f6",
  "Appt Set": "#06b6d4",
  "Listing Appointment": "#10b981",
  Deferred: "#64748b",
  "Next Year": "#0ea5e9",
};

// Tailwind bg-* equivalents of STAGE_COLORS (same palette hues), for places
// that want a class instead of a hex — e.g. the board column underline.
// Mirrors getBuyerStageColor in buyerLeadStages.js.
const STAGE_BG_CLASSES = {
  "Open House Leads": "bg-sky-600",
  "New Lead": "bg-slate-400",
  Contacted: "bg-blue-500",
  "Appt Set": "bg-cyan-500",
  "Listing Appointment": "bg-emerald-500",
  Deferred: "bg-slate-500",
  "Next Year": "bg-sky-500",
};

export const getListingStageColor = (stage) =>
  STAGE_BG_CLASSES[stage] || "bg-slate-300";

export const SOURCE_LABELS = {
  referral: "Referral",
  zillow: "Zillow",
  past_client: "Past Client",
  open_house: "Open House",
  sphere: "Sphere",
};

export function isGraduationStage(stage) {
  return stage === GRADUATION_STAGE;
}

// Parking columns — an appointment outcome, not a step on the path to market.
// Cards are placed here by status (or drag), never by "advance".
export const PARKING_STAGES = ["Deferred", "Next Year"];

export function nextStage(stage) {
  const i = LISTING_STAGES.indexOf(stage);
  // Unknown/legacy stage: start at New Lead, never the auto-intake column
  // (that column is only ever reached by the open-house trigger).
  if (i === -1) return "New Lead";
  for (let j = i + 1; j < LISTING_STAGES.length; j++) {
    if (!PARKING_STAGES.includes(LISTING_STAGES[j])) return LISTING_STAGES[j];
  }
  return stage === GRADUATION_STAGE ? stage : GRADUATION_STAGE;
}
